module.exports = new __parcel__URL__("leaderboard_stardust_button.f6b0860d.png").toString();